import axios from "axios";

export default {

    data: () => ({
        users: '',
        companies: '',
        page : 1,
        pages : 0,
        phone : '',
    }),

    mounted() {
        this.get_users()
    },

    methods: {
        async get_users() {
            this.$store.commit('progress_status', true)
            await axios({
                method: "GET",
                url: "/users",
                headers: {
                    token: sessionStorage.getItem("token")
                },
                params:{
                    page : this.page,
                    phone : this.phone,
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.users = res.data
                    this.pages = res.data.pages
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        },

        show_all(){
            this.phone = ''
            this.get_users()
        },


        more(id) {
            // this.companies = []
            let mores = document.getElementsByClassName('more')
            this.get_more(id)

            for (let i = 0; i < mores.length; i++) {
                if (mores[i].id === 'more' + id) {
                    document.getElementById('more' + id).classList.add('d-block')
                    document.getElementById('more' + id).classList.remove('d-none')
                }
                if (mores[i].id !== 'more' + id) {
                    document.getElementById(mores[i].id).classList.remove('d-block')
                    document.getElementById(mores[i].id).classList.add('d-none')
                }
            }
        },


        async get_more(id) {
            this.$store.commit('progress_status', true)
            await axios({
                method: "GET",
                url: "/user-companies",
                headers: {
                    token: sessionStorage.getItem("token")
                },
                params: {
                    user: id
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.companies = res.data
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        },

    }
};